<template>
  <div class="space-y-2 py-4">
    <div v-if="primary" class="text-gray-500 text-sm font-medium">Primary</div>
    <div class="flex space-x-2 items-start">
      <div class="w-64">
        <PhoneNumberForm
          :save-action="updatePhoneNumber"
          :phone-number="phoneNumber"
          :disabled="loading"
        />
      </div>
      <div class="flex none">
        <BaseButton ghost :disabled="loading" @click="deletePhoneNumber"> Delete </BaseButton>
      </div>
      <div v-if="!primary" class="flex none">
        <BaseButton ghost :disabled="loading" @click="makePhoneNumberPrimary">
          Make primary
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { contactPhoneNumbersClient, contactPrimaryPhoneNumbersClient } from '@/api/clients';
import PhoneNumberForm from './PhoneNumberForm.vue';

export default {
  components: {
    PhoneNumberForm,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
    phoneNumber: {
      type: Object,
      required: true,
    },
    primary: Boolean,
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async updatePhoneNumber(formData) {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactPhoneNumbersClient.update(this.contactId, this.phoneNumber.id, formData);

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    async makePhoneNumberPrimary() {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactPrimaryPhoneNumbersClient.store(this.contactId, {
          number: this.phoneNumber.number,
        });

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    async deletePhoneNumber() {
      if (this.loading) {
        return Promise.resolve();
      }

      try {
        this.loading = true;

        await contactPhoneNumbersClient.destroy(this.contactId, this.phoneNumber.id);

        await this.onChange();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
